import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Feeling excited 🤓 to be able to find a magic trick for old MFC-7360N's duplex scanning.`}</p>
    <h1>{`Best CLI of Today`}</h1>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`pdftk `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`A`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`even.pdf `}<span parentName="code" {...{
            "className": "token assign-left variable"
          }}>{`B`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`odd.pdf shuffle A Bend-1 output merged.pdf`}</code></pre></div>
    <p>{`This command reverses document `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`B`}</code>{` and then shuffles with `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`A`}</code>{`. Fast and easy. No need to upload pdf to unreliable website or install any bulky pricy software. Just one line.`}</p>
    <p>{`In Mac OS X El Captain, please install `}<a parentName="p" {...{
        "href": "https://www.pdflabs.com/tools/pdftk-the-pdf-toolkit/pdftk_server-2.02-mac_osx-10.11-setup.pkg"
      }}>{`this one`}</a>{`.`}</p>
    <p>{`Just love these `}<a parentName="p" {...{
        "href": "https://www.pdflabs.com/docs/pdftk-cli-examples/"
      }}>{`one liners`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      